import templateUrl from './tag.html';

export const tagComponent = {
	templateUrl,
	bindings: {
		items: '<',
		onRemove: '&'
	},
	controller: class TagComponent {
        remove(tag) {
            this.items = this.items.filter((name) => name !== tag);
            this.onRemove({
                $event: {
                    tag: tag
                }
            });
        }
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/tag/tag.component.js